export const WHOLESALER_SUBDOMAIN_GET_REQUEST = 'WHOLESALER_SUBDOMAIN_GET_REQUEST';
export const WHOLESALER_SUBDOMAIN_GET_SUCCESS = 'WHOLESALER_SUBDOMAIN_GET_SUCCESS';
